import { defineComponent as u, openBlock as o, createElementBlock as e, mergeProps as a, unref as l, renderSlot as m, createElementVNode as n, createCommentVNode as g } from "vue";
import { useScalarIcon as A } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, f = { key: 1 }, k = { key: 2 }, h = { key: 3 }, w = { key: 4 }, y = { key: 5 }, M = {
  name: "ScalarIconCircle"
}, b = /* @__PURE__ */ u({
  ...M,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const d = s, { bind: i, weight: r } = A(d);
    return (p, t) => (o(), e("svg", a({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(i)), [
      m(p.$slots, "default"),
      l(r) === "bold" ? (o(), e("g", Z, t[0] || (t[0] = [
        n("path", { d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Z" }, null, -1)
      ]))) : l(r) === "duotone" ? (o(), e("g", f, t[1] || (t[1] = [
        n("path", {
          d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z" }, null, -1)
      ]))) : l(r) === "fill" ? (o(), e("g", k, t[2] || (t[2] = [
        n("path", { d: "M232,128A104,104,0,1,1,128,24,104.13,104.13,0,0,1,232,128Z" }, null, -1)
      ]))) : l(r) === "light" ? (o(), e("g", h, t[3] || (t[3] = [
        n("path", { d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Z" }, null, -1)
      ]))) : l(r) === "regular" ? (o(), e("g", w, t[4] || (t[4] = [
        n("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z" }, null, -1)
      ]))) : l(r) === "thin" ? (o(), e("g", y, t[5] || (t[5] = [
        n("path", { d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  b as default
};
